import React, { useEffect, useRef, useState } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { ShieldCheck, LockFill, FileEarmarkCheck, PeopleFill } from 'react-bootstrap-icons';
import './trustCompliance.css';

function useOnScreen(ref, rootMargin = "0px") {
  const [isIntersecting, setIntersecting] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIntersecting(entry.isIntersecting),
      { rootMargin }
    );
    if (ref.current) observer.observe(ref.current);
    return () => {
      if (ref.current) observer.unobserve(ref.current);
    };
  }, []);
  return isIntersecting;
}

const badgeData = [
  {
    icon: <ShieldCheck />,
    title: 'Trusted & Compliant',
    desc: 'Trusted platform adhering to all legal requirements.'
  },
  {
    icon: <LockFill />,
    title: '256‑bit SSL Encryption',
    desc: 'Your data is secured with end-to-end 256-bit encryption, ensuring maximum protection.'
  },
  {
    icon: <FileEarmarkCheck />,
    title: 'Privacy & Audit',
    desc: 'Regular independent audits and strict privacy compliance maintained consistently.'
  },
  {
    icon: <PeopleFill />,
    title: 'Trusted by 1,00,000+ Customers',
    desc: 'Proudly serving over one lakh satisfied clients with excellence and integrity.'
  }
];

const TrustCompliance = () => {
  const ref = useRef();
  const onScreen = useOnScreen(ref, "-100px");

  return (
    <section className="tc-section py-5" ref={ref}>
      <Container>
        <Row className="mb-4">
          <Col lg={6}>
            <h2 className={`tc-title ${onScreen ? 'tc-fade-in-up' : 'tc-invisible'}`}>Trust & Compliance</h2>
            <p className={`tc-subtitle ${onScreen ? 'tc-fade-in-up tc-delay-1' : 'tc-invisible'}`}>
              We ensuring secure transactions and full transparency to earn your trust at every step.
            </p>
          </Col>
        </Row>
        <Row>
          {badgeData.map((badge, idx) => (
            <Col key={idx} md={6} lg={3} className="mb-4">
              <Card className={`tc-card ${onScreen ? `tc-fade-in-up tc-delay-${idx + 2}` : 'tc-invisible'}`}>
                <Card.Body className="d-flex flex-column align-items-center text-center">
                  <div className="tc-icon-wrapper mb-3">
                    {badge.icon}
                  </div>
                  <Card.Title className="tc-card-title">{badge.title}</Card.Title>
                  <Card.Text className="tc-card-desc">{badge.desc}</Card.Text>
                  {/* Optional: button/link */}
                  {/* <a href="#" className="tc-learn-more">Learn More →</a> */}
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default TrustCompliance;
